import { render, staticRenderFns } from "./stockAdjustments.vue?vue&type=template&id=c3602e46&"
import script from "./stockAdjustments.vue?vue&type=script&lang=js&"
export * from "./stockAdjustments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports